import { render, staticRenderFns } from "./NoticeInfo.vue?vue&type=template&id=4fa76b1a&scoped=true&"
import script from "./NoticeInfo.vue?vue&type=script&lang=js&"
export * from "./NoticeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa76b1a",
  null
  
)

export default component.exports